import {
  Avatar,
  Box,
  Button,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { ChatListWrapper } from "./ChatListWrapper";
import { useState } from "react";

export const ChatList = ({ conversations, setSelectedConversation }) => {
  const handleConversationSelect = (conversationId: number) => {
    setSelectedConversation(conversationId);
  };
  return (
    <ChatListWrapper>
      <Box p={2}>
        <Typography variant="h6">Chats</Typography>
      </Box>
      <Divider />
      <List>
        {conversations.map((conversation) => (
          <ListItem
            key={conversation.id}
            component={Button}
            sx={{
              textTransform: "none",
              justifyContent: "flex-start",
              "&.Mui-selected": {
                backgroundColor: "action.selected",
              },
            }}
            onClick={() => handleConversationSelect(conversation.id)}
          >
            <ListItemAvatar>
              <Avatar>{conversation.name[0]}</Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={conversation.name}
              secondary={
                <>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                    sx={{ display: "block" }}
                  >
                    {conversation.last_message?.body}
                  </Typography>
                  <Typography
                    component="span"
                    variant="caption"
                    color="textSecondary"
                  >
                    {new Date(
                      conversation.last_message?.created_at
                    ).toLocaleTimeString()}
                  </Typography>
                </>
              }
            />
            {conversation.unread_count > 0 && (
              <Chip
                label={conversation.unread_count}
                color="primary"
                size="small"
                sx={{ ml: 1 }}
              />
            )}
          </ListItem>
        ))}
      </List>
    </ChatListWrapper>
  );
};
